import AdminUserDocumentReport from "./AdminUserDocumentReport";

export default AdminUserDocumentReport;
